'use strict';

module.exports = {
    UNAVIALABLE_SERVICE: 'Hizmet şu anda kullanılamıyor. Lütfen daha sonra tekrar deneyin.',
    NEED_ACTIVE: 'Hesabınız {{account}} bu web sitesini ilk defa kullanıyor. Lütfen etkinleştirme işlemini tamamlamak için {{activeLink}} ve bu sayfaya dönerek işlemlere devam edin',
    GOTO_ACTIVE: 'Hemen etkinleştir',
    NOT_ACTIVED: 'Bu hesap etkinleştirilmemiş, lütfen etkinleştirme işlemini tamamlamak için {{activeLink}}',
    COMPLETE_ACTIVE: 'Etkinleştirmeyi onayla',
    FORBID_ACTIVE: "Bu hesap AliExpress'te desteklenmiyor!",
    SIGN_UP_WITH_ANOTHER_ACCOUNT: 'Lütfen farklı bir hesapla oturum açın',
    ACTIVE_PAGE: 'hesap etkinleştirme sayfasına gidin'
};